import { useEffect } from "react";
import "../Profile/index.less";
import { effect, useStore } from "../../../utils/dva16";
import { NLogin, EGet, MNotes } from "../../../models/contants";
import { Helmet } from "react-helmet";
import { customizeRenderEmpty } from "../../../utils/utils";
import { Divider } from "antd";

const IFRAME_CONFIGS = {
	"All Regions":
		"https://app.powerbi.com/view?r=eyJrIjoiODUzYjgwMTMtMmY5Ni00MzRjLWEwOGQtN2ViYzdlYzkyMjg1IiwidCI6IjQ5NDkyZjUwLTk2NTEtNGYyNC1hYjFkLWMzNmQ0NzRlNWZmMyIsImMiOjZ9",
	China:
		"https://app.powerbi.com/view?r=eyJrIjoiMWNkM2UwZmQtNGNhNC00Nzc0LTgwZDMtYjRmMjc3Y2VkMmI0IiwidCI6IjQ5NDkyZjUwLTk2NTEtNGYyNC1hYjFkLWMzNmQ0NzRlNWZmMyIsImMiOjZ9",
	"East Asia":
		"https://app.powerbi.com/view?r=eyJrIjoiODIxNmRmMTAtMTQ5Ny00OWFmLWI3YzItYzAxNDc5NGVjNmFjIiwidCI6IjQ5NDkyZjUwLTk2NTEtNGYyNC1hYjFkLWMzNmQ0NzRlNWZmMyIsImMiOjZ9",
	"China + East Asia":
		"https://app.powerbi.com/view?r=eyJrIjoiZmJhOTNlN2MtMjA3My00YzYwLTkzZTgtYzQ2ZThkZjNhOGU5IiwidCI6IjQ5NDkyZjUwLTk2NTEtNGYyNC1hYjFkLWMzNmQ0NzRlNWZmMyIsImMiOjZ9",
	MENA: "https://app.powerbi.com/view?r=eyJrIjoiMjg5MTUxMTItMzBjNi00NGNlLTgwZWUtNzk1NjEwYTJiMzZjIiwidCI6IjQ5NDkyZjUwLTk2NTEtNGYyNC1hYjFkLWMzNmQ0NzRlNWZmMyIsImMiOjZ9",
	SEA: "https://app.powerbi.com/view?r=eyJrIjoiMDEzOGQxMmUtNWYwYi00MzhiLTk4NjItYzI1OTNmOTg1M2IyIiwidCI6IjQ5NDkyZjUwLTk2NTEtNGYyNC1hYjFkLWMzNmQ0NzRlNWZmMyIsImMiOjZ9",
	India:
		"https://app.powerbi.com/view?r=eyJrIjoiMjhmZmVlY2QtMjM1MS00MzNiLWE2MjAtMTVjZTEwM2FmZmZkIiwidCI6IjQ5NDkyZjUwLTk2NTEtNGYyNC1hYjFkLWMzNmQ0NzRlNWZmMyIsImMiOjZ9",
};

const MarketModelIframe = ({ title, src }) => (
	<iframe
		title={`Market Model - ${title}`}
		style={{ width: "100%", height: "100vh", margin: "20px" }}
		src={src}
		frameBorder="0"
		allowFullScreen
	/>
);

export default (props) => {
	const { currentSubscribe, userInfo } = useStore(NLogin);
	const { marketNotes } = useStore(MNotes);

	useEffect(() => {
		effect(NLogin, EGet, {});
		effect(MNotes, EGet);
	}, []);

	const getIframeToRender = () => {
		if (userInfo?.type !== "Client") {
			// Non-client default view
			return (
				<MarketModelIframe
					title="Default"
					src={IFRAME_CONFIGS["All Regions"]}
				/>
			);
		}

		const modules = currentSubscribe?.module?.["MarketModel"];
		if (!modules || modules?.length === 0) return customizeRenderEmpty();

		const hasChina = modules?.includes("China");
		const hasEastAsia = modules?.includes("East Asia");

		if (modules?.length === 1 && hasChina) {
			return <MarketModelIframe title="China" src={IFRAME_CONFIGS["China"]} />;
		}

		if (modules?.length === 2 && hasChina && hasEastAsia) {
			return (
				<MarketModelIframe
					title="China + East Asia"
					src={IFRAME_CONFIGS["China + East Asia"]}
				/>
			);
		}

		if (modules?.length === 5) {
			return (
				<MarketModelIframe
					title="All Regions"
					src={IFRAME_CONFIGS["All Regions"]}
				/>
			);
		}

		// If multiple modules, render them all
		return modules?.map((region) =>
			IFRAME_CONFIGS[region] ? (
				<MarketModelIframe
					key={region}
					title={region}
					src={IFRAME_CONFIGS[region]}
				/>
			) : null,
		);
	};

	return (
		<div
			style={{
				display: "flex",
				justifyContent: "center",
				flexDirection: "column",
			}}
		>
			<Helmet>
				<script
					dangerouslySetInnerHTML={{
						__html: `
                            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                            })(window,document,'script','dataLayer','GTM-N9T2Q4PW');
                        `,
					}}
				/>
				{/* Google tag (gtag.js) */}
				<script
					async
					src="https://www.googletagmanager.com/gtag/js?id=G-6049TJDB50"
				></script>
				<script>
					{`
         				window.dataLayer = window.dataLayer || [];
        				function gtag(){dataLayer.push(arguments);}
          			gtag('js', new Date());
         				gtag('config', 'G-6049TJDB50');
        	`}
				</script>
			</Helmet>

			{getIframeToRender()}

			<Divider
				style={{
					borderWidth: "2px",
					borderColor: "rgb(219 218 218)",
					margin: "25px 20px",
				}}
			/>
			<div
				className="marketNotes"
				dangerouslySetInnerHTML={{
					__html: marketNotes && marketNotes?.[0]?.note,
				}}
				style={{ margin: "0 20px" }}
			/>
		</div>
	);
};
